import { CtaButton } from "./CtaButton";

export function MobileBar() {
  return (
    <div className="rrb-mobilebar md:hidden" data-testid="mobile-sticky-bar">
      <CtaButton kind="call" size="sm" tone="soft" testId="mobile-call-btn" className="rrb-mobile-call" />
      <CtaButton kind="eligibility" testId="mobile-eligibility-btn" className="flex-1" />
    </div>
  );
}
